export const LANGUAGE = [
  { id: '1', label: 'En', value: 'en', icon: 'icon-flag-en' },
  { id: '2', label: 'No', value: 'no', icon: 'icon-flag-no' },
];
